<template>
  <div
    class="copy-link"
    :class="{ disabled }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">

interface Props {
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

</script>

<style lang="scss">
@import "@/assets/style/include.scss";

.copy-link {
  height: $input-height;
  width: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: $input-border;
  border-left: none;
  cursor: pointer;
  border-bottom-right-radius: 12px;
  border-top-right-radius: 12px;
  color: $colorBlue1;
  transition: border-color $transition-speed,
  background-color $transition-speed,
  color $transition-speed;


  &:hover {
    background: $colorBlue1;
    color: $color-white;
    border-color: $colorBlue1;
  }

  &:active {
    background: $btn-bg-primary_active;
    color: $color-white;
    border-color: $btn-bg-primary_active;
  }

  &.disabled {
    pointer-events: none;
    background: $bgLight2;
    color: darken($colorGrayDisabled, 20%);
    border-color: $bgLight2;
  }
}
</style>
